// Capture real-user performance (LCP, INP, CLS, etc.) and forward to Sentry & telemetry
import { telemetry } from './utils/telemetry';
// Support current web-vitals version via dynamic import of get* APIs
type Metric = { name: string; value: number; id: string };

function send(metric: Metric){
  if(!metric) return;
  telemetry.push({ type: 'web-vital', name: metric.name, value: metric.value, id: metric.id });
  const g:any = (window as any);
  if (g.__SENTRY__?.hub) {
    try { g.__SENTRY__?.hub?.getClient()?.captureEvent?.({ message: `web-vital:${metric.name}`, level: 'info', tags: { web_vital: metric.name }, extra: { value: metric.value, id: metric.id } }); } catch {}
  }
}

import('web-vitals').then(api => {
  try { api.getLCP(send); } catch {}
  try { api.getCLS(send); } catch {}
  try { api.getFID(send); } catch {}
  try { api.getTTFB(send); } catch {}
  try { (api as any).getINP && (api as any).getINP(send); } catch {}
});
